import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77bae7fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "third_bind"
}
const _hoisted_2 = { class: "bind_title" }
const _hoisted_3 = {
  key: 0,
  class: "bind_subTitle"
}
const _hoisted_4 = {
  key: 1,
  class: "bind_subTitle"
}
const _hoisted_5 = { class: "platfroms_h5" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "lineAgein",
  src: "https://static-jp.theckb.com/static-asset/activity/line/line_bind_icon_4.png",
  alt: ""
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "other_method" }, "メールアドレスで登録", -1))
const _hoisted_11 = { class: "formBox" }
const _hoisted_12 = { class: "form-item flex" }
const _hoisted_13 = { class: "label" }
const _hoisted_14 = {
  key: 0,
  class: "required"
}
const _hoisted_15 = { class: "label-title" }
const _hoisted_16 = {
  key: 1,
  class: "required_jp"
}
const _hoisted_17 = { class: "fx-1" }
const _hoisted_18 = ["src"]
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "form-item flex" }
const _hoisted_21 = { class: "label" }
const _hoisted_22 = {
  key: 0,
  class: "required"
}
const _hoisted_23 = { class: "label-title" }
const _hoisted_24 = {
  key: 1,
  class: "required_jp"
}
const _hoisted_25 = { class: "err-msg" }
const _hoisted_26 = { class: "form-item" }
const _hoisted_27 = {
  key: 0,
  class: "label"
}
const _hoisted_28 = { class: "form-item flex" }
const _hoisted_29 = {
  key: 0,
  class: "required"
}
const _hoisted_30 = { class: "label-title" }
const _hoisted_31 = {
  key: 1,
  class: "required_jp"
}
const _hoisted_32 = { class: "err-msg" }
const _hoisted_33 = { class: "form-item flex" }
const _hoisted_34 = {
  key: 0,
  class: "required"
}
const _hoisted_35 = { class: "label-title" }
const _hoisted_36 = {
  key: 1,
  class: "required_jp"
}
const _hoisted_37 = { class: "err-msg" }
const _hoisted_38 = { class: "form-item" }
const _hoisted_39 = {
  key: 0,
  class: "label"
}
const _hoisted_40 = {
  key: 0,
  class: "sendCodetips"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/login/icon_Attention.png",
  alt: ""
}, null, -1))
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" 認証コードを送信しました。 ")
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" 迷惑メールフォルダもご確認のうえ、30分以内にコードをご入力ください。 ")
const _hoisted_45 = [
  _hoisted_41,
  _hoisted_42,
  _hoisted_43,
  _hoisted_44
]
const _hoisted_46 = { class: "form-item flex" }
const _hoisted_47 = { class: "label" }
const _hoisted_48 = {
  key: 0,
  class: "required"
}
const _hoisted_49 = { class: "label-title" }
const _hoisted_50 = {
  key: 1,
  class: "required_jp"
}
const _hoisted_51 = { class: "err-msg" }
const _hoisted_52 = {
  key: 2,
  class: "form-item flex"
}
const _hoisted_53 = { class: "label" }
const _hoisted_54 = { class: "label-title" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "no_required_jp" }, "任意", -1))
const _hoisted_56 = { class: "err-msg" }
const _hoisted_57 = {
  key: 3,
  class: "form-item flex"
}
const _hoisted_58 = {
  class: /*#__PURE__*/_normalizeClass(`label `)
}
const _hoisted_59 = { class: "label-title" }
const _hoisted_60 = {
  key: 0,
  class: "no_required_jp"
}
const _hoisted_61 = {
  key: 4,
  class: "form-item aucfun flex"
}
const _hoisted_62 = { class: "label" }
const _hoisted_63 = {
  key: 0,
  class: "required"
}
const _hoisted_64 = { class: "label-title" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-tishi tooltip_icon iconfont-tishi" }, null, -1))
const _hoisted_66 = { class: "aucfanEmalTip" }
const _hoisted_67 = {
  key: 1,
  class: "required_jp"
}
const _hoisted_68 = { class: "err-msg" }
const _hoisted_69 = {
  key: 5,
  class: "form-item flex"
}
const _hoisted_70 = { class: "label" }
const _hoisted_71 = { class: "label-title" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_74 = {
  key: 0,
  class: "no_required_jp"
}
const _hoisted_75 = { class: "err-msg" }
const _hoisted_76 = { class: "flex-start" }
const _hoisted_77 = ["innerHTML"]
const _hoisted_78 = { class: "err-msg no_wrap" }
const _hoisted_79 = { class: "sign-btn-content" }
const _hoisted_80 = {
  key: 0,
  src: "https://static-jp.theckb.com/static-asset/activity/expressFee/express_tip.png",
  alt: "",
  class: "sign-tag"
}
const _hoisted_81 = {
  key: 0,
  src: "https://static-jp.theckb.com/static-asset/activity/sign_tag_1201.png",
  alt: "",
  class: "sign-tag"
}
const _hoisted_82 = {
  key: 0,
  class: "signup_success",
  style: {"visibility":"hidden"}
}
const _hoisted_83 = {
  key: 0,
  class: "other_page"
}
const _hoisted_84 = { key: 0 }
const _hoisted_85 = { key: 1 }
const _hoisted_86 = { class: "other_method" }
const _hoisted_87 = { class: "platfroms" }
const _hoisted_88 = ["onClickPassive"]
const _hoisted_89 = ["onClick"]
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "lineAgein",
  src: "https://static-jp.theckb.com/static-asset/activity/line/line_bind_icon_3.png",
  alt: ""
}, null, -1))
const _hoisted_91 = [
  _hoisted_90
]
const _hoisted_92 = ["src", "alt"]
const _hoisted_93 = ["innerHTML"]
const _hoisted_94 = {
  key: 1,
  class: "toBind"
}
const _hoisted_95 = /*#__PURE__*/_createTextVNode("すでにTHE CKBアカウントをお持ちの場合は、")
const _hoisted_96 = /*#__PURE__*/_createTextVNode("からログイン・連携してください")

import { request } from '@/config/request/interceptors'
import {
  reactive,
  ref,
  onMounted,
  nextTick,
  watch,
  computed,
  h
} from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { ArrowLeftBold, Warning } from '@element-plus/icons-vue'
import TermModal from '@/components/termModal/index.vue'

import {
  getSignupCode,
  signup as signApi,
  activateSub,
  checkInvitationCode,
  getEffectTermByType,
  getInvitationInfo,
  getMobileCode,
  MobileCodeParams,
  isBind,
  loginByPwd
} from '@/apis/login'
import { useRequest } from '@/util/useLoading'
import { t, changeLang } from '@/plugins/i18n'
import { isEmojiCharacter, wait } from '@/plugins/utils'
import { signup as createRules } from './rules'
import { useGetCode } from './utils'
import { countries, countryOptions, tips, Value } from './const'

import SvgIcon from '@/components/icons/SvgIcon.vue'
import {
  CountriesEnum,
  Site,
  japanStationCor2Country,
  koreaStationCor2Country,
  ukStationCor2Country,
  Term,
  compTripartitePlatforms,
  countryMapSite,
  Plat
} from '@/common/const'
import { ElMessage } from 'element-plus'
import { openAuth2, AuthResponse, UserInfo, platType, getQueryParams } from '@/plugins/tripartite-login'
import {
  REMOVE_TRIPARTITEUSERINFO,
  TripartiteUserInfo
} from '@/store/modules/tripartite'
import { R, isJA, useSite, isEN } from '@/store'
import { taTrack, TaEvent, thinkingdata } from '@/util/buryingPoint'
import SignIntroduce from '@/views/signup/components/SignIntroduce.vue'

interface Props {
  /** boolean则是弹窗  string则是激活/创建子账号 */
  isRam?: string | boolean,
  h5?: boolean
}


export default /*#__PURE__*/_defineComponent({
  props: {
    isRam: { type: [String, Boolean], required: false },
    h5: { type: Boolean, required: false }
  },
  emits: ['success', 'cancel', 'update:panel'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  /** boolean则是弹窗  string则是激活/创建子账号 */
  isRam?: string | boolean,
  h5?: boolean
}
const goToLine = () => {
  window.location.href = '/hub/line'
}

const isShowExpressFeeActivityTip = computed(() => {
  return false
})
const locationSearch = window.location.search
// 注册渠道 email 邮箱 phone 手机号
const signupType = ref('email')
// 协议连接
const termFileUrl = ref('')
const store = useStore<R>()

const lineActivity = computed(() => store.getters.lineActivity)

// 机器认证
const showRecaptcha = ref(false)
const vueRecaptchaRef = ref()
// 获取人机校验接口
const recaptchaVerified = async (res: any) => {
  form.recaptchaCode = res
  getPhoneCode({ customerMobile: form.customerMobile, globalRoaming: form.countryCode, bizType: 1, countryPlaceCode: form.countryPlaceCode, recaptchaCode: res } as MobileCodeParams)
  showRecaptcha.value = false
}
const recaptchaExpired = () => {
  vueRecaptchaRef.value.reset()
}




// 若屏幕占用宽度小于700，则展示h5样式
const showh5Style = ref<boolean>(window.screen?.availWidth < 700)
const route = useRoute()
const router = useRouter()
const isJa = computed(() => isJA())
/** 注册表单 */
const formRef = ref()
/** 协议弹窗 */
const termModal = ref()
/** 协议内容 */
const term = ref()
/** 国家手机区域列表 */
const mobileAreaCodeOptions = ref<{ value: string; label: string }[]>([])
/** 是否显示密码 */
// const showPassWord = ref(false)
/** 邀请码是否不可编辑 */
const invitationCodeDisable = ref(false)
/** 国家是否不可编辑 */
const countryPlaceCodeDisable = ref(false)
// 所有站点的用户协议
const termDataList: any = ref([])
/** 是否注册完成 */
const signupSuccess = ref(false)

/** 通过邀请码获取国家站点信息 */
const countriesInfo = ref({
  country: '',
  stationCode: '',
  langCode: ''
})

/** 站点信息 */
const stationCode = ref<Site>()
/** 注册绑定的三方平台 */
const signinPlatform = ref<string>('')
/** store内的三方绑定信息 */
const tripartitePlatformInfo = computed<TripartiteUserInfo>(
  () => store.state.tripartite
)

// 是否Aucfan 注册
const isAucfan = computed(() => route.query.channel === '1' && route.query.code === 'af0001')

/** 验证推广码是否为正确的推广联盟 */
const isSmcCode = ref(false)
const countryPlaceCode: any = (!props.isRam ? localStorage.getItem('countryKey') : '') || countries.find((item) => item.navigatorLang.includes(navigator.language))?.key || CountriesEnum.other
// 如果是弹窗则根据当前国家展示
if (props.isRam) {
  // todo 20231116邮箱注册  setItem没处理英国站  临时解决下
  if (!isEN()) {
    localStorage.setItem('countryKey', isJA() ? 'JP' : 'KO')
  } else {
    // todo 应该选中当前站点语言对应国家  临时写死UK
    localStorage.setItem('countryKey', CountriesEnum.UK)
  }
}
const countriesList = ref(countryOptions)

/** 注册表单值 */
const form = reactive<Value>({
  countryPlaceCode: CountriesEnum.Japan,
  gender: 3,
  verificationCode: '',
  countryCode: '',
  customerMobile: '',
  isagree: false,
  recommendationEmail: '',
  invitationCode: String(route.query.code ?? ''),
  recaptchaCode: '',
  corpName: ''
})
const { count, disabled, getPhoneCode, getCode } = useGetCode(
  'signupCode',
  getSignupCode,
  getMobileCode
)
// 渠道
const channel = ref('')
const channelGroup = ref('')

/** 表单验证规则 */
const rules = ref(createRules(form, disabled))
const defaultImageUrl = 'https://static-jp.theckb.com/static-asset/client/loginLogo.svg'

/** 登录并绑定点击功能区分 */
const toLogin = () => {
  const path = window.location.href
  // 若当前不是在/login,则应该是切换弹窗
  if (!path.includes('signup')) {
    store.commit('status/loginPanel', 'login')
  } else {
    router.push('/login')
  }
}

watch(() => store.getters.site, (val) => {
  // countriesList.value = getCountryOptions()
  let res = countryOptions
  if (props.isRam) {
    if (val === 'en') {
      res = res.filter(item => item.key !== 'JP' && item.key !== 'KR')
      return res
    } else {
      res = res.filter(item => item.key === (val === 'ja' ? 'JP' : 'KR'))
    }
  }
  countriesList.value = res
})

const getCountryOptions = (isAll = true) => {

}
const { query } = useRoute()
const [loading, submit] = useRequest(
  async () => {
    const { ...data } = form
    // 子账号注册
    if (typeof props.isRam === 'string') {
      const res = await activateSub({
        ...tripartitePlatformInfo.value,
        ...form,
        stationCode: stationCode.value,
        customerShopId: props.isRam
      })
      if (res.success) {
        // store.commit('route/SET_LOGIN_NAME', data.loginName)
        emits('success', res.data?.uuid)
        store.commit(REMOVE_TRIPARTITEUSERINFO)
        return wait()
      }
    } else {
      // 主账号注册
      const find = countries.find((country) => country.key === form.countryPlaceCode)
      // 默认携带from
      const res = await signApi({
        platformType: props.h5 ? 4 : 1,
        buType: 1,
        ...tripartitePlatformInfo.value,
        ...data,
        spm: String(route.query.spm ?? ''),
        channel: channelGroup.value ? `${channel.value}${channelGroup.value}` : channel.value,
        ext: route.query,
        invitationCode:
          form.invitationCode === 'itsumo' ? '001342' : String(form.invitationCode) || String(route.query.code || ''),
        utcTimeZone:
          form.countryPlaceCode === CountriesEnum.other
            ? getTimeZoneByBowser()
            : find?.time as string,
        stationCode: stationCode.value,
        termId: termDataList.value.find((i: any) => i.stationCode === stationCode.value)?.termId,
        initShopFlag: 1,
        thirdPlatform: query.thirdShopAuth ? 11 : tripartitePlatformInfo.value?.thirdPlatform
      })
      if (res.success) {
        signupSuccess.value = true
        store.commit(REMOVE_TRIPARTITEUSERINFO)
        emits('success', res.data?.uuid, channel.value, data)
        store.commit('route/SET_LOGIN_NAME', data.loginName)
        if (isJA()) {
          // 刚注册的新用户
          sessionStorage.setItem('newUser', '1')
        }
        return wait()
      }
    }
  },
  {
    onError: console.log
  }
)

/** 选中国家的国旗url */
const getSelectedCountryFlagUrl = (key?: string) =>
  countryOptions.find((op) => op.key === key)?.nationalFlagUrl || 'https://static-s.theckb.com/BusinessMarket/Client/JP.png'

/** 获取验证码码 */
const getVerifyCode = async () => {
  if (count.value > 0) return
  taTrack({
    event: TaEvent.REGISTER,
    value: {
      step_id: 'get_verification_code'
    }
  })
  const checkResult = await formRef.value.validateField([
    signupType.value === 'email' ? 'customerEmail' : 'customerMobile'
  ])
  console.log(checkResult)
  if (checkResult) {
    // 发送邮箱验证
    if (signupType.value === 'email') {
      getCode({ customerEmail: form.customerEmail, countryPlaceCode: form.countryPlaceCode })
      return
    }
    // 发送手机号验证码
    getPhoneCode({ customerMobile: form.customerMobile, globalRoaming: form.countryCode, bizType: 1, countryPlaceCode: form.countryPlaceCode } as MobileCodeParams)
  }
}

/** 返回浏览器当前的UTC时间偏移量 */
const getTimeZoneByBowser = () => {
  // 获取本地时间
  const localTime = new Date()

  // 计算UTC偏移量（以分钟为单位）
  const utcOffset = (localTime.getTimezoneOffset() / 60) * -1

  if (utcOffset >= 0) {
    return `UTC+${utcOffset}`
  } else {
    return `UTC${utcOffset}`
  }
}

/** 根据国家站点获取用户协议 */
const fetchTerm = async (state = stationCode.value as Site) => {
  try {
    const list = await getEffectTermByType({
      stationCode: state,
      type: Term.utilize
    })
    termDataList.value = [...list.data]
  } catch (error) {
    ElMessage.error(t('查询条款失败'))
  }
}

const getStationTerm = () => {
  console.log('222', stationCode.value)
  return termDataList.value.find((i: any) => i.stationCode === stationCode.value)?.fileUrl
}
/**
 * 验证邀请码
 * @param val 邀请码
 * @param notNeedRequest 是否需要请求
 */
const validInvitationCode = async (val: string, notNeedRequest?: boolean) => {
  if (!notNeedRequest) {
    if (val === 'itsumo') {
      await getCountryInvitationInfo('001342')
    } else {
      await getCountryInvitationInfo(val)
    }
  }

  const res = await checkInvitationCode({
    invitationCode: val
  })
  if (res?.success) {
    isSmcCode.value = res.data
  }
  // 如果路由上code存在，且为推广码，且该推广码正确
  if (route.query.code && res.data && countriesInfo.value?.country) {
    if (countriesInfo.value.stationCode === Site.EN) {
      countryPlaceCodeDisable.value = false
      invitationCodeDisable.value = true
      rules.value = createRules(form, disabled)
      return
    }
    countryPlaceCodeDisable.value = true
    invitationCodeDisable.value = true
    rules.value = createRules(form, disabled)
    return
  }
  if (route.query.redirect?.includes('choice')) {
    countryPlaceCodeDisable.value = true
    setTimeout(() => {
      form.countryPlaceCode = CountriesEnum.Japan
    })
  }
  if (res.data && countriesInfo.value?.country) {
    if (countriesInfo.value.stationCode === Site.EN) {
      countryPlaceCodeDisable.value = false
      rules.value = createRules(form, disabled)
      return
    }
    countryPlaceCodeDisable.value = true
    rules.value = createRules(form, disabled)
    return
  }
  countryPlaceCodeDisable.value = false
  invitationCodeDisable.value = false
  rules.value = createRules(form, disabled)
}
/** 判断国家是否disabled */
const getSingleCountryDisabled = (country: string) => {
  // 如果邀请码存在且正确，且站点为英国站站点,如果不是英国站的国家则不能选择
  if (isSmcCode.value && countriesInfo.value.stationCode === Site.EN && !ukStationCor2Country.includes(country)) {
    return true
  }
  return false
}

/**
 * 切换国家
 * @param val 国家站点
 */
const handleCountryChange = (val: CountriesEnum) => {
  const _invitationCode = form.invitationCode
  val && localStorage.setItem('countryKey', val)
  formRef.value && formRef.value.resetFields()
  //   如果是推广联盟邀请码，且是英国站点,则切换国家的时候邀请码不用置空
  if (isSmcCode.value && countriesInfo.value.stationCode === Site.EN) {
    form.invitationCode = _invitationCode
  }
  const find = countries.find((country) => country.key === val)
  let globalLangType: 'en' | 'ja' | 'ko' = 'en'
  const list = [find!.mobileAreaCode]
    .filter((code) => code)
    .map((code) => ({
      value: code,
      label: code
    }))
    .concat({
      label: '—',
      value: ''
    })
  mobileAreaCodeOptions.value = list
  form.countryCode = list[0].value

  if (japanStationCor2Country.includes(val)) {
    globalLangType = 'ja'
    stationCode.value = Site.JA
    signupType.value = 'email'
  }
  if (koreaStationCor2Country.includes(val)) {
    globalLangType = 'ko'
    stationCode.value = Site.KO
  }
  if (ukStationCor2Country.includes(val)) {
    globalLangType = 'en'
    stationCode.value = Site.EN
  }
  form.countryPlaceCode = val
  // 以弹窗形式打开的，不changeLangType，因为会刷新app/且langType本无需变化
  store.commit('route/site', globalLangType)
  changeLang(globalLangType)
}
/** 打开协议 */
const catTerm = async (fileUrl = '') => {
  termFileUrl.value = fileUrl || getStationTerm()
  nextTick(() => {
    if (termFileUrl.value) {
      termModal.value.open()
    }
  })
}
/** 同意点击 */
const onagree = () => {
  form.isagree = true
}
/** 不同意 */
const ondisAgree = () => {
  form.isagree = false
}
/** 表单第二步验证 */
const finishRegist = async () => {
  // 因为第一步校验通过，所以全部校验，避免写if/else
  const checkResult = await formRef.value.validate()
  if (checkResult) {
    submit()
  }
}
/**
 * 三方授权回调
 * @param userInfo 用户信息回调
 */
const authCallback = async (userInfo?: TripartiteUserInfo) => {
  const res = await isBind({
    thirdPlatform: userInfo?.thirdPlatform,
    thirdCustomerId: userInfo?.thirdCustomerId
  })
  if (res.success) {
    const isbind = res.data?.isBind
    // 已经绑定过我们的账号,直接登录
    if (isbind) {
      const res2: any = await loginByPwd({
        password: '',
        nameOrEmail: '',
        thirdPlatform: userInfo?.thirdPlatform as string,
        thirdCustomerId: userInfo?.thirdCustomerId as string
      })
      if (res2?.success) {
        store.commit('status/onLogin', false)
        // 第一次注册，选择完平台后
        if (res2.data.uuid && !res2.data.token) {
          store.commit('route/uuid', res2.data.uuid)

          if (props.h5) {
            router.replace({ name: 'signup_h5', query })
          } else {
            router.replace({ name: 'signup' })
          }
        } else {
          const query = route.query
          const { redirect, from } = query ?? {}
          // 判断是否是h5商品详情推广页跳转过来的 如果是的就还要跳转回去
          if (redirect) {
            await store.dispatch('route/changeToken', res2.data.token)
            window.location.replace(decodeURIComponent(redirect.toString()))
          } else {
            await store.dispatch('route/refreshToken', res2.data.token)
          }
        }
      } else {
        if (res?.code === '24010003' && form.recaptchaCode) {
          form.recaptchaCode = ''
        }
      }
    }
    signinPlatform.value = userInfo?.thirdPlatform ?? ''
    const customerEmail = userInfo?.thirdCustomerEmail as string
    if (customerEmail) {
      // formRef.value.validateField(['customerEmail'])
      form.customerEmail = userInfo?.thirdCustomerEmail as string
    }
    form.customerMobile = userInfo?.thirdCustomerPhone as string
    // 针对line仅日本授权
    if (userInfo?.thirdPlatform === Plat.LE) {
      forceSetJa()
    }
  }
}

/** 三方授权点击 */
const registerByPlatform = (platform: string) => {
  openAuth2(
    {
      plat: platform as platType,
      h5: props.h5
    },
    rsp => authCallback(rsp.userInfo)
  )
}

// 切换国家获取默认列表及手机号等，及规则
watch(
  () => form.countryPlaceCode,
  (countryPlaceCode) => {
    if (!countryPlaceCode) {
      getDefaultOptions()
    }
    fetchTerm()
    rules.value = createRules(form, disabled)
  }
)

/** 通过code获取站点信息 */
const getCountryInvitationInfo = async (code: string) => {
  // 新加接口判断code是正确

  const resInfo = await getInvitationInfo({
    invitationCode: code
  })
  // 说明邀请码不正确
  if (!resInfo.success || !resInfo.data) {
    countriesInfo.value = resInfo.data
    getDefaultOptions()
    return
  }

  countriesInfo.value = resInfo.data
  // 切换用户语言
  changeLang(resInfo.data?.langCode as ('ko' | 'ja' | 'en'))
  stationCode.value = resInfo.data?.stationCode as Site

  const find = countries.find((item) =>
    item.key === resInfo.data.country) ||
  {
    key: CountriesEnum.Japan,
    desc: '日本',
    navigatorLang: ['ja'],
    mobileAreaCode: '+81'
  }

  // 如果国家信息存在则将国家回显
  form.countryPlaceCode = (resInfo.data?.country ?? CountriesEnum.Japan) as CountriesEnum

  localStorage.setItem('countryKey', form.countryPlaceCode!)
  // 挂载时，需根据表单选中的国家，改变其手机区号的值和选项
  form.countryCode = find?.mobileAreaCode
  store.commit('route/site', resInfo.data?.langCode)
}

/** 强制设定为日本 */
const forceSetJa = (disabled = true) => {
  changeLang('ja')
  store.commit('route/site', 'ja')
  stationCode.value = Site.JA
  form.countryCode = '+81'
  form.countryPlaceCode = CountriesEnum.Japan
  // 国家是否可以选择
  countryPlaceCodeDisable.value = disabled
}

const isShowAcitvityTag = ref(false)
// // 是否是日语浏览器
// const isJapanese = ref(false);
onMounted(async () => {
  // 根据授权信息回填
  if (tripartitePlatformInfo.value.thirdPlatform) {
    authCallback(tripartitePlatformInfo.value)
    signinPlatform.value = tripartitePlatformInfo.value.thirdPlatform
  }
  // signinPlatform.value = 'google'
  const { data } = await request.market.activitySceneConfig.customerQuery({})
  isShowAcitvityTag.value = data?.activityInfo?.sceneType === 1 && !data.couponInfo?.endDate

  // const browserLanguage = navigator.language;
  // isJapanese.value = browserLanguage.startsWith('ja');
})

/** 走默认配置语言设置 */
const getDefaultOptions = () => {
  // 没有找对应语言的国家，默认日本
  const find = countries.find((item) =>
    item.navigatorLang.includes(store.getters.site === 'en' ? navigator.language : store.getters.site || navigator.language)
  ) || {
    key: CountriesEnum.other,
    desc: 'Other Countries And Regions',
    navigatorLang: ['*'],
    mobileAreaCode: ''
  }
  // 缓存国家key JP...  缓存key > 浏览器
  const cacheKey = localStorage.getItem('countryKey') as CountriesEnum
  // 弹窗不允许选中语言，所以与内部战点语言保持一致
  if (typeof props.isRam === 'boolean' && props.isRam) {
    form.countryPlaceCode = (isEN() ? cacheKey : '') || find?.key || CountriesEnum.other
  } else {
    form.countryPlaceCode = cacheKey || find?.key
  }

  localStorage.setItem('countryKey', form.countryPlaceCode)
  // 挂载时，需根据表单选中的国家，改变其手机区号的值和选项
  form.countryCode = find?.mobileAreaCode
  // 获取默认站点信息
  if (japanStationCor2Country.includes(form.countryPlaceCode)) {
    stationCode.value = Site.JA
  }
  if (koreaStationCor2Country.includes(form.countryPlaceCode)) {
    stationCode.value = Site.KO
  }
  if (ukStationCor2Country.includes(form.countryPlaceCode)) {
    stationCode.value = Site.EN
  }
  console.log('getDefaultOptions', stationCode.value)
}
const isItsumoSignup = ref(false)
watch(() => route.query, async (val) => {
  if (isAucfan.value) {
    // 如果路由携带code参数，则是推广者联盟/acufn => 国家固定为日本，且无法选择国家
    forceSetJa()
    if (isAucfan.value) {
      invitationCodeDisable.value = true
    }
  }
  if (route.query.channel === 'itsumo') {
    forceSetJa(false)
    form.invitationCode = 'itsumo'
    form.invitationCode && validInvitationCode('001342')
    channel.value = '0'
    isItsumoSignup.value = true
  } else if (route.query.channel === '1688') {
    forceSetJa(false)
  } else {
    if (route.query.code) {
      // 如果路由携带code参数，则是推广者联盟 => 国家固定为日本，且无法选择国家
      form.invitationCode = String(route.query.code ?? '')
      form.invitationCode && validInvitationCode(form.invitationCode)
    }

    channel.value = String(route.query.channel ?? '')
    // 默认走缓存语言配置
    getDefaultOptions()
    form.countryPlaceCode && handleCountryChange(form.countryPlaceCode)
  }
  if (route.query.channel_group) {
    channelGroup.value = route.query.channel_group as string
  }
  fetchTerm()
}, { immediate: true })
// 切换邮箱or 手机号
const changeSignupType = (type: string) => {
  taTrack({
    event: TaEvent.REGISTER,
    value: {
      step_id: type === 'email' ? 'click_email_register' : 'click_phone_register'
    }
  })
  signupType.value = type
  form.customerEmail = ''
  form.customerMobile = ''
}
// defineExpose({
//   getStep
// })

const useEmailTips = ref()
const usePhoneRef = ref()
const inputPaddingRight = computed(() => {
  // 22 左右各11
  return `${((signupType.value === 'phone' ? useEmailTips?.value?.offsetWidth : usePhoneRef?.value?.offsetWidth) || 0) + 22}px`
})

return (_ctx: any,_cache: any) => {
  const _component_ElButton = _resolveComponent("ElButton")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["signForm", { sign_h5: __props.h5 }])
  }, [
    (signinPlatform.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('注册并绑定您的THE CKB账户')), 1),
          (_unref(isJA)())
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, " 登録後、" + _toDisplayString(signinPlatform.value) + "アカウントでもログイン可能になります ", 1))
            : _createCommentVNode("", true),
          (!_unref(isJA)())
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(t)('只需绑定一次，后续可用{platform}直接登录', {
          platform: signinPlatform.value
        })), 1))
            : _createCommentVNode("", true)
        ]))
      : (__props.h5 && _unref(isJA)())
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(compTripartitePlatforms), (platform) => {
                return (_openBlock(), _createBlock(_component_ElButton, {
                  key: platform.key,
                  class: _normalizeClass([platform.key, "platform_h5"]),
                  onClick: ($event: any) => (registerByPlatform(platform.key))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: platform.logoUrl,
                      alt: _unref(t)('平台logo'),
                      height: "24",
                      width: "24"
                    }, null, 8, _hoisted_6),
                    _createTextVNode(" " + _toDisplayString(_unref(t)(platform.name)) + " ", 1),
                    (_unref(isJA)() && platform.key === 'line')
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          onClick: _withModifiers(goToLine, ["stop"])
                        }, _hoisted_9, 8, _hoisted_7))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["class", "onClick"]))
              }), 128))
            ]),
            _createVNode(_component_el_divider, null, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            })
          ], 64))
        : _createCommentVNode("", true),
    _createVNode(_component_el_form, {
      ref: (_value, _refs) => {
        _refs['formRef'] = _value
        formRef.value = _value
      },
      model: _unref(form),
      rules: rules.value,
      "validate-on-rule-change": false,
      class: _normalizeClass([__props.h5 && 'sign_h5_form', _unref(isEN)() && 'lang_en'])
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _withDirectives(_createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              (!_unref(isJA)())
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, "*"))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(t)('国家/地区')), 1),
              (_unref(isJA)())
                ? (_openBlock(), _createElementBlock("span", _hoisted_16, "必须"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_el_form_item, {
                prop: "country",
                class: "country_select"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _unref(form).countryPlaceCode,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).countryPlaceCode) = $event)),
                    onChange: handleCountryChange,
                    disabled: !!countryPlaceCodeDisable.value || typeof __props.isRam === 'string',
                    "popper-append-to-body": false
                  }, {
                    prefix: _withCtx(() => [
                      _createElementVNode("img", {
                        src: getSelectedCountryFlagUrl(_unref(form).countryPlaceCode),
                        alt: "当前选中国家的国旗图片",
                        class: "selected-country-img"
                      }, null, 8, _hoisted_19)
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countriesList.value, (op) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: op.key,
                          value: op.key,
                          label: op.desc,
                          disabled: getSingleCountryDisabled(op.key)
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: op.nationalFlagUrl,
                              alt: "",
                              class: "country_img"
                            }, null, 8, _hoisted_18),
                            _createElementVNode("span", null, _toDisplayString(op.desc), 1)
                          ]),
                          _: 2
                        }, 1032, ["value", "label", "disabled"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              _withDirectives(_createElementVNode("div", { class: "countryTips" }, _toDisplayString(_unref(t)('注册成功后国家/地区无法更改，请谨慎选择')), 513), [
                [_vShow, !__props.isRam]
              ])
            ])
          ], 512), [
            [_vShow, !(_unref(isJA)() && __props.h5 && _unref(form).countryPlaceCode === 'JP')]
          ]),
          (signupType.value === 'phone')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    (!_unref(isJA)())
                      ? (_openBlock(), _createElementBlock("span", _hoisted_22, "*"))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(t)('手机号')), 1),
                    (_unref(isJA)())
                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, "必须"))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_el_form_item, {
                    class: "fx-1",
                    prop: "customerMobile"
                  }, {
                    error: _withCtx((error) => [
                      _createElementVNode("div", _hoisted_25, _toDisplayString(error.error), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "phone",
                        class: "customerMobile",
                        modelValue: _unref(form).customerMobile,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).customerMobile) = $event)),
                        modelModifiers: { trim: true },
                        placeholder: _unref(t)(_unref(tips)[12]),
                        maxlength: 50
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            class: "countryCode",
                            modelValue: _unref(form).countryCode,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).countryCode) = $event)),
                            style: {"width":"68px"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mobileAreaCodeOptions.value, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"]),
                      _createElementVNode("span", {
                        ref: (_value, _refs) => {
                          _refs['useEmailTips'] = _value
                          useEmailTips.value = _value
                        },
                        type: "text",
                        class: "phone",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (changeSignupType('email')))
                      }, _toDisplayString(_unref(t)('使用邮箱注册')), 513)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_26, [
                  (!__props.h5)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        class: "sendCode",
                        color: "#FEEEE8",
                        disabled: _unref(count) > 0,
                        onClick: getVerifyCode
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(count) > 0 ?
                `${_unref(t)('已发送{X}S', { X: _unref(count) })}` : _unref(t)('获取验证码')), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", {
                    class: _normalizeClass(`label  ${stationCode.value === _unref(Site).EN ? 'label-en' : ''}`)
                  }, [
                    (!_unref(isJA)())
                      ? (_openBlock(), _createElementBlock("span", _hoisted_29, "*"))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(t)('手机验证码')), 1),
                    (_unref(isJA)())
                      ? (_openBlock(), _createElementBlock("span", _hoisted_31, "必须"))
                      : _createCommentVNode("", true)
                  ], 2),
                  _createVNode(_component_el_form_item, {
                    prop: "verificationCode",
                    class: "fx-1"
                  }, {
                    error: _withCtx((error) => [
                      _createElementVNode("div", _hoisted_32, _toDisplayString(error.error), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "number",
                        modelValue: _unref(form).verificationCode,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).verificationCode) = $event)),
                        modelModifiers: { trim: true },
                        placeholder: _unref(t)(_unref(tips)[6]),
                        maxlength: 15
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ], 64))
            : (signupType.value === 'email')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", {
                      class: _normalizeClass(`label  ${stationCode.value === _unref(Site).EN ? 'label-en' : ''}`)
                    }, [
                      (!_unref(isJA)())
                        ? (_openBlock(), _createElementBlock("span", _hoisted_34, "*"))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_35, _toDisplayString(_unref(t)('邮箱')), 1),
                      (_unref(isJA)())
                        ? (_openBlock(), _createElementBlock("span", _hoisted_36, "必须"))
                        : _createCommentVNode("", true)
                    ], 2),
                    _createVNode(_component_el_form_item, {
                      class: "fx-1 rel",
                      prop: "customerEmail"
                    }, {
                      error: _withCtx((error) => [
                        _createElementVNode("div", _hoisted_37, _toDisplayString(error.error), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          class: "customerMobile",
                          type: "email",
                          placeholder: _unref(isJA)() ? '例: yamada@sniffjapan.com' : '',
                          modelValue: _unref(form).customerEmail,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).customerEmail) = $event)),
                          modelModifiers: { trim: true },
                          maxlength: 50
                        }, null, 8, ["placeholder", "modelValue"]),
                        (!_unref(isJA)())
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              ref: (_value, _refs) => {
                                _refs['usePhoneRef'] = _value
                                usePhoneRef.value = _value
                              },
                              type: "text",
                              class: "phone",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (changeSignupType('phone')))
                            }, _toDisplayString(_unref(t)('使用手机号注册')), 513))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    (!__props.h5)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          class: "sendCode",
                          color: "#FEEEE8",
                          disabled: _unref(count) > 0,
                          onClick: getVerifyCode
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(count) > 0 ?
                `${_unref(t)('已发送{X}S', { X: _unref(count) })}` : _unref(t)('获取验证码')), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  (_unref(count) && _unref(isJA)())
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, _hoisted_45))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      (!_unref(isJA)())
                        ? (_openBlock(), _createElementBlock("span", _hoisted_48, "*"))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_49, _toDisplayString(_unref(t)('邮箱验证码')), 1),
                      (_unref(isJA)())
                        ? (_openBlock(), _createElementBlock("span", _hoisted_50, "必须"))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_el_form_item, {
                      prop: "verificationCode",
                      class: "fx-1"
                    }, {
                      error: _withCtx((error) => [
                        _createElementVNode("div", _hoisted_51, _toDisplayString(error.error), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          class: "verificationCode",
                          type: "number",
                          modelValue: _unref(form).verificationCode,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(form).verificationCode) = $event)),
                          modelModifiers: { trim: true },
                          placeholder: _unref(t)(_unref(tips)[6]),
                          maxlength: 15
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ], 64))
              : _createCommentVNode("", true),
          (_unref(isJA)())
            ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("span", _hoisted_54, _toDisplayString(_unref(t)('手机号')), 1),
                  _hoisted_55
                ]),
                _createVNode(_component_el_form_item, {
                  class: "fx-1",
                  prop: "customerMobile"
                }, {
                  error: _withCtx((error) => [
                    _createElementVNode("div", _hoisted_56, _toDisplayString(error.error), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      placeholder: "例: 07012345678",
                      type: "phone",
                      class: _normalizeClass(["customerMobile", showh5Style.value ? 'phone-input-h5' : 'phone-input customerMobile_withLoginForm']),
                      modelValue: _unref(form).customerMobile,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(form).customerMobile) = $event)),
                      modelModifiers: { trim: true },
                      maxlength: 50
                    }, {
                      prepend: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          class: "countryCode",
                          modelValue: _unref(form).countryCode,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(form).countryCode) = $event)),
                          style: {"width":"68px"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mobileAreaCodeOptions.value, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "class"])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_unref(isJA)())
            ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("span", _hoisted_59, _toDisplayString(_unref(t)('公司名称')), 1),
                  (_unref(isJA)())
                    ? (_openBlock(), _createElementBlock("span", _hoisted_60, "任意"))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_el_form_item, {
                  class: "fx-1",
                  prop: "corpName"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      resize: "none",
                      rows: 2,
                      type: "textarea",
                      placeholder: "個人経営の方は「個人」とご入力ください",
                      modelValue: _unref(form).corpName,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(form).corpName) = $event)),
                      maxlength: "50"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_unref(isAucfan))
            ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                _createElementVNode("div", _hoisted_62, [
                  (!_unref(isJA)())
                    ? (_openBlock(), _createElementBlock("span", _hoisted_63, "*"))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_64, [
                    _createTextVNode(" Aucfan.com" + _toDisplayString(_unref(t)('注册邮箱')) + " ", 1),
                    _createVNode(_component_el_popover, {
                      placement: "bottom",
                      width: 300,
                      trigger: "hover"
                    }, {
                      reference: _withCtx(() => [
                        _hoisted_65
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_66, _toDisplayString(_unref(t)('输入Aucfan的注册邮箱提示')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  (_unref(isJA)())
                    ? (_openBlock(), _createElementBlock("span", _hoisted_67, "必须"))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_el_form_item, {
                  class: "fx-1",
                  prop: "recommendationEmail"
                }, {
                  error: _withCtx((error) => [
                    _createElementVNode("div", _hoisted_68, _toDisplayString(error.error), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "text",
                      modelValue: _unref(form).recommendationEmail,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(form).recommendationEmail) = $event)),
                      maxlength: "50"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]))
            : (typeof (__props.isRam as any) !== 'string')
              ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                  _createElementVNode("div", _hoisted_70, [
                    _createElementVNode("span", _hoisted_71, [
                      _createTextVNode(_toDisplayString(_unref(t)('邀请码')) + " ", 1),
                      _createVNode(_component_el_tooltip, {
                        placement: "top",
                        effect: "dark"
                      }, {
                        content: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('为了告知介绍大使会员的用户名')), 1),
                          _hoisted_72,
                          _createTextVNode(" " + _toDisplayString(_unref(t)('请不要在用户名中注册包含能够识别个人身份的信息，比如真实姓名等。')), 1),
                          _hoisted_73,
                          _createTextVNode(" " + _toDisplayString(_unref(t)('如果用户名中包含您的个人信息，请事先同意提供给推广者会员。')), 1)
                        ]),
                        default: _withCtx(() => [
                          _withDirectives(_createVNode(_component_el_icon, { color: "#A1A1A1" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Warning))
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, isSmcCode.value]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    (_unref(isJA)())
                      ? (_openBlock(), _createElementBlock("span", _hoisted_74, "任意"))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_el_form_item, {
                    class: "fx-1",
                    prop: "invitationCode"
                  }, {
                    error: _withCtx((error) => [
                      _createElementVNode("div", _hoisted_75, _toDisplayString(error.error), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "text",
                        placeholder: _unref(isJA)() ? 'お持ちの方のみご入力ください' : '',
                        modelValue: _unref(form).invitationCode,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(form).invitationCode) = $event)),
                        disabled: invitationCodeDisable.value || isItsumoSignup.value,
                        maxlength: "6",
                        onChange: validInvitationCode
                      }, null, 8, ["placeholder", "modelValue", "disabled"])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
        ]),
        (_openBlock(), _createElementBlock("div", {
          class: "footer",
          key: _unref(form).countryCode
        }, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_76, [
              _createVNode(_component_el_form_item, {
                prop: "isagree",
                class: "is-agree"
              }, {
                error: _withCtx((valid) => [
                  _createElementVNode("div", _hoisted_78, [
                    _createElementVNode("span", null, _toDisplayString(valid.error), 1)
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_checkbox, {
                    style: _normalizeStyle({
                '--el-checkbox-checked-text-color': 'rgba(0,0,0,.88)',
                '--el-checkbox-checked-bg-color': '#FA541C',
                '--el-checkbox-checked-input-border-color': '#FA541C',
                '--el-checkbox-input-border-color-hover': '#FA541C',
              }),
                    modelValue: _unref(form).isagree,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(form).isagree) = $event)),
                    size: "large",
                    class: "is-argee"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        class: "term",
                        innerHTML: _unref(t)('同意用户协议'),
                        onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (catTerm()), ["prevent"]))
                      }, null, 8, _hoisted_77)
                    ]),
                    _: 1
                  }, 8, ["style", "modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_79, [
              (_unref(isShowExpressFeeActivityTip))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_unref(form).countryPlaceCode === 'JP')
                      ? (_openBlock(), _createElementBlock("img", _hoisted_80))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_unref(form).countryPlaceCode === 'JP' && isShowAcitvityTag.value)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_81))
                      : _createCommentVNode("", true)
                  ], 64)),
              _createVNode(_component_el_button, {
                class: "sign_btn",
                color: "#FF5010",
                type: "success",
                loading: _unref(loading),
                onClick: finishRegist
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('注册完成')), 1)
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            (signupSuccess.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_82, "registration successful"))
              : _createCommentVNode("", true)
          ]),
          (!signinPlatform.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                (!__props.isRam)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                      _createVNode(_component_router_link, {
                        class: "to-login",
                        to: __props.h5 ? `/login_h5${_unref(locationSearch)}` : '/login'
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('去登录')), 1)
                        ]),
                        _: 1
                      }, 8, ["to"]),
                      _createVNode(_component_el_divider, { direction: "vertical" }),
                      _createVNode(_component_router_link, {
                        class: "to-index",
                        to: '/' + _unref(useSite)()
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('首页')), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_85, [
                      _createElementVNode("span", {
                        class: "openLoginModal",
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_unref(store).commit('status/loginPanel', 'login')))
                      }, _toDisplayString(_unref(t)('去登录')), 1)
                    ]))
              ]))
            : _createCommentVNode("", true),
          (!signinPlatform.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (!(__props.h5 && _unref(isJA)()))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_el_divider, null, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_86, _toDisplayString(_unref(t)('其他登录方法')), 1)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_87, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(compTripartitePlatforms), (platform) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: platform.key,
                            class: _normalizeClass([platform.key, "platform rel"]),
                            onClickPassive: ($event: any) => (registerByPlatform(platform.key))
                          }, [
                            (_unref(isJA)() && platform.key === 'line')
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  onClick: _withModifiers(goToLine, ["stop"])
                                }, _hoisted_91, 8, _hoisted_89))
                              : _createCommentVNode("", true),
                            _createElementVNode("img", {
                              src: platform.logoUrl,
                              alt: _unref(t)('平台logo'),
                              height: "30",
                              width: "30"
                            }, null, 8, _hoisted_92)
                          ], 42, _hoisted_88))
                        }), 128))
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (!_unref(isJA)())
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "toBind",
                      onClick: toLogin,
                      innerHTML: _unref(t)('已有CKB账户，去【登录并绑定】')
                    }, null, 8, _hoisted_93))
                  : (_openBlock(), _createElementBlock("div", _hoisted_94, [
                      _hoisted_95,
                      _createElementVNode("span", { onClick: toLogin }, "こちら"),
                      _hoisted_96
                    ]))
              ], 64))
        ]))
      ]),
      _: 1
    }, 8, ["model", "rules", "class"]),
    _createVNode(TermModal, {
      ref: (_value, _refs) => {
        _refs['termModal'] = _value
        termModal.value = _value
      },
      title: _unref(t)('利用规约'),
      onagree: onagree,
      "ondis-agree": ondisAgree,
      "file-url": termFileUrl.value,
      timer: false
    }, null, 8, ["title", "file-url"]),
    (__props.h5)
      ? (_openBlock(), _createBlock(SignIntroduce, {
          key: 2,
          h5: true
        }))
      : _createCommentVNode("", true)
  ], 2))
}
}

})